// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// const initialState: any = {
//     timeline: {}
// };

// export const timelineSlice = createSlice({
//   name: 'timeline',
//   initialState,
//   reducers: {
//     setTimeline: (state, action: PayloadAction<any[]>) => {
//       state.timeline = action.payload;
//     }
//   }
// });

// export const { setTimeline } = timelineSlice.actions;

// export default timelineSlice.reducer;



import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  timeline: {}
};

export const timelineSlice = createSlice({
  name: 'timeline',
  initialState,
  reducers: {
    setTimeline: (state, action: PayloadAction<any[]>) => {
      state.timeline = action.payload;
    },
    updateWatchLaterAt: (
      state,
      action: PayloadAction<{ seriesId: string; date: string }>
    ) => {
      const seriesList = state.timeline.series || [];

      state.timeline.series = seriesList.map((series: any) => {
        if (series.seriesId === action.payload.seriesId) {
          return {
            ...series,
            seriesWatchLaterAt: action.payload.date
          };
        }
        return series;
      });
    }
  }
});

export const { setTimeline, updateWatchLaterAt } = timelineSlice.actions;
export default timelineSlice.reducer;
